import styled from 'styled-components'

export const PricingItem = styled.div`
box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
margin-bottom: 20px;
margin-top: ${props => props.active ? " -29px" : "0px"};
@media (max-width:758px){
    margin-top: 0px;
}
`;

export const PricingItemHeader = styled.div`
height: 50px;
width: 100%;
background-color: ${props => props.color};
display:flex;
justify-content: center;
align-items: center;
h5{
    font-weight:700;
    color:white;
}
`;

export const PricingItemPrix = styled.div`
height: 54px;
display: flex;
justify-content: center;
align-items: center;
background-color: #FBFBFB;
h4{
    font-weight: 700;
    color:  ${props => props.color};
}
`;

export const PricingItemContent = styled.div`
text-align:center;
p{
    margin-bottom: 10px;
    padding: 10px 0px;
    font-size: 13px;
    color: #404040;   
}
p:not(:last-child){
    border-bottom: 1px solid #ebebeb;
}
`;

export const PricingItemfooter = styled.div`
height: 50px;
display: flex;
justify-content: center;
align-items: center;
background-color: ${props => props.color};
a{
    color: white;
    font-weight: 600;
    font-size: 17px;
    letter-spacing: 1px;
}   
`;

